import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router';
import { environment } from '@env/environment';
import { catchError, map, of } from 'rxjs';
import { PermissionsService } from 'shared/services';
import { removeQueryParamsFromUrl } from '../util/removeQueryParamsFromUrl';

/**
 * Guard that checks if the user has access to the resource.
 *
 * It uses the permissions service to check if the user has access to the resource.
 *
 * The permissions must be configured in the permissions.ts file.
 *
 * For the urls.x.y permissions, the url configuration must also match the permission path.
 */
@Injectable()
export class ResourcePermissionsGuard implements CanActivate {
    constructor(
        private permissionsService: PermissionsService,
        private router: Router,
    ) {}

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        // Remove UUIDs from the URL
        let url = state.url.replace(/\b[a-f\d-]{36}((\b\/)|$)/g, '');
        // Remove trailing slash if it exists
        url = url.replace(/\/$/, '');
        url = removeQueryParamsFromUrl(url);
        url = url.replaceAll('/', '.');

        return this.permissionsService.userHasAccess('urls' + url).pipe(
            map((result: boolean) => {
                if (!result) {
                    window.history.replaceState(null, '', `/dashboard`);
                    this.router.navigate(['/dashboard']);

                    if (environment.production) {
                        //console.error('User doesn't have access to this resource or no resource permissions have been configured.', url);
                    }
                }
                //console.info('User has access to this resource.', url);
                return result;
            }),
            catchError(() => {
                console.log('in catcherror');
                window.history.replaceState(null, '', `/dashboard`);
                this.router.navigate(['/dashboard']);
                return of(false);
            }),
        );
    }
}
